import { useEffect, useState } from 'react';

/**
 * The value, settled.
 *
 * Returns `value` only once it has stopped changing for `delay` ms, so a search
 * box can drive a query without firing one request per keystroke.
 */
export function useDebouncedValue<T>(value: T, delay = 350): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return settled;
}
